import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user.model';

export const login = createAction('[Auth] Log In', props<{ username: string; password: string }>());
export const loginSuccess = createAction('[Auth] Login Success', props<{ user: User }>());
export const loginFailure = createAction('[Auth] Login Failure', props<{ error: any }>());
export const logout = createAction('[Auth] Log Out');

export const rehydrate = createAction('[Auth] Rehydrate Auth Store', props<{ userId: string }>());
export const rehydrateSuccess = createAction('[Auth] Rehydrate Success', props<{ user: User }>());
export const rehydrateFailure = createAction('[Auth] Rehydrate Failure');
